<!-- The tenant navbar belongs to a tenant session; a back-office page load holds
     a platform token the API refuses outside /platform, so it gets its own chrome. -->
@if (!fullscreen.chromeHidden() && !backOffice) {
	<sh-navbar></sh-navbar>
}
<div
	class="flex-grow w-full bg-surface-page"
	[ngClass]="fullscreen.chromeHidden() ? '' : 'px-4 sm:px-6 lg:px-8'"
>
	<p-toast appendTo="body" [baseZIndex]="10000" />
	<!-- Answers the app-wide ConfirmationService, e.g. the unsaved-changes guard; page dialogs listen to their own. -->
	<p-confirmDialog />
	<router-outlet />
</div>